import {
  Button,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { FormattedMessage, useIntl } from 'react-intl';

import { useDeleteSaudiRewardsAccount } from 'queries/accounts/useDeleteSaudiRewardsAccount';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const SaudiRewardsUnlinkAccount = ({ open, onClose, onSuccess }: Props) => {
  const { deleteLinkedSaudiRewardsAccount, isLoading } =
    useDeleteSaudiRewardsAccount();
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();

  const handleUnlinkAccount = () => {
    deleteLinkedSaudiRewardsAccount(undefined, {
      onSuccess: () => {
        enqueueSnackbar(
          intl.formatMessage({ id: 'saudi.rewards.unlink.success.alert' }),
          { variant: 'success' },
        );
        onSuccess();
      },
      onError: () => {
        enqueueSnackbar(
          intl.formatMessage({ id: 'saudi.rewards.unlink.error.alert' }),
          { variant: 'error' },
        );
      },
    });
  };
  return (
    <>
      <ResponsiveDrawerDialog isOpen={open} onClose={onClose}>
        <DialogTitle>
          <FormattedMessage id="account.settings.unlink.saudi.rewards.account" />
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="smallParagraph"
            sx={{
              color: 'text.secondary',
              mb: 3,
            }}
          >
            <FormattedMessage id="account.settings.unlink.saudi.rewards.account.description" />
          </Typography>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: 3,
            }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleUnlinkAccount}
              sx={{ width: { md: 'fit-content' } }}
              loading={isLoading}
            >
              <FormattedMessage id="account.settings.unlink.saudi.rewards.account.cta.confirm" />
            </Button>
            <Button
              variant="text"
              onClick={onClose}
              sx={{ width: { md: 'fit-content' } }}
            >
              <FormattedMessage id="account.settings.unlink.saudi.rewards.account.cta.cancel" />
            </Button>
          </Stack>
        </DialogContent>
      </ResponsiveDrawerDialog>
    </>
  );
};

export default SaudiRewardsUnlinkAccount;
